import { defineMessages } from 'react-intl'
import { invertObjectUtil } from 'packages/src'

export const MUSCLE = {
  // Chest
  CHEST: 100,

  // Back
  UPPER_BACK: 200,
  MIDDLE_BACK: 201,
  LOWER_BACK: 202,
  LATS: 203,
  TRAPS: 204,
  NECK: 205,
  INFRASPINATUS: 206,

  // Arms
  BICEPS: 300,
  TRICEPS: 301,
  FOREARMS: 302,

  // Shoulders
  SHOULDERS: 400,

  // Legs
  QUADRICEPS: 500,
  HAMSTRINGS: 502,
  CALVES: 503,
  ABDUCTORS: 504,
  ADDUCTORS: 505,
  HIP_FLEXORS: 506,

  // Glutes
  GLUTES: 501,

  // Abdomen
  ABS: 600,
  OBLIQUES: 601
}

export const MUSCLE_TO_KEY = invertObjectUtil(MUSCLE)

const messages = defineMessages({
  chest: {
    id: 'muscle.chest',
    defaultMessage: 'Chest',
    description: 'The label used for the Chest muscle'
  },
  upperBack: {
    id: 'muscle.upperBack',
    defaultMessage: 'Upper Back',
    description: 'The label used for the Upper Back muscle'
  },
  middleBack: {
    id: 'muscle.middleBack',
    defaultMessage: 'Middle Back',
    description: 'The label used for the Middle Back muscle'
  },
  lowerBack: {
    id: 'muscle.lowerBack',
    defaultMessage: 'Lower Back',
    description: 'The label used for the Middle Back muscle'
  },
  lats: {
    id: 'muscle.lats',
    defaultMessage: 'Lats',
    description: 'The label used for the Lats muscle'
  },
  traps: {
    id: 'muscle.traps',
    defaultMessage: 'Traps',
    description: 'The label used for the Traps muscle'
  },
  neck: {
    id: 'muscle.neck',
    defaultMessage: 'Neck',
    description: 'The label used for the Neck muscle'
  },
  biceps: {
    id: 'muscle.biceps',
    defaultMessage: 'Biceps',
    description: 'The label used for the Biceps muscle'
  },
  triceps: {
    id: 'muscle.triceps',
    defaultMessage: 'Triceps',
    description: 'The label used for the Triceps muscle'
  },
  forearms: {
    id: 'muscle.forearms',
    defaultMessage: 'Forearms',
    description: 'The label used for the Forearms muscle'
  },
  shoulders: {
    id: 'muscle.shoulders',
    defaultMessage: 'Shoulders',
    description: 'The label used for the Shoulders muscle'
  },
  quadriceps: {
    id: 'muscle.quadriceps',
    defaultMessage: 'Quadriceps',
    description: 'The label used for the Quadriceps muscle'
  },
  glutes: {
    id: 'muscle.glutes',
    defaultMessage: 'Glutes',
    description: 'The label used for the Glutes muscle'
  },
  hamstrings: {
    id: 'muscle.hamstrings',
    defaultMessage: 'Hamstrings',
    description: 'The label used for the Hamstrings muscle'
  },
  calves: {
    id: 'muscle.calves',
    defaultMessage: 'Calves',
    description: 'The label used for the Calves muscle'
  },
  abductors: {
    id: 'muscle.abductors',
    defaultMessage: 'Abductors',
    description: 'The label used for the Abductors muscle'
  },
  adductors: {
    id: 'muscle.adductors',
    defaultMessage: 'Adductors',
    description: 'The label used for the Adductors muscle'
  },
  hipFlexors: {
    id: 'muscle.hipFlexors',
    defaultMessage: 'Hip Flexors',
    description: 'The label used for the Hip Flexors muscle'
  },
  abs: {
    id: 'muscle.abs',
    defaultMessage: 'Abs',
    description: 'The label used for the Abs muscle'
  },
  obliques: {
    id: 'muscle.obliques',
    defaultMessage: 'Obliques',
    description: 'The label used for the Obliques muscle'
  }
})

export const MUSCLE_MESSAGE = {

  // Chest
  [MUSCLE.CHEST]: messages.chest,

  // Back
  [MUSCLE.UPPER_BACK]: messages.upperBack,
  [MUSCLE.MIDDLE_BACK]: messages.middleBack,
  [MUSCLE.LOWER_BACK]: messages.lowerBack,
  [MUSCLE.LATS]: messages.lats,
  [MUSCLE.TRAPS]: messages.traps,
  [MUSCLE.NECK]: messages.neck,

  // Arms
  [MUSCLE.BICEPS]: messages.biceps,
  [MUSCLE.TRICEPS]: messages.triceps,
  [MUSCLE.FOREARMS]: messages.forearms,

  // Shoulders
  [MUSCLE.SHOULDERS]: messages.shoulders,

  // Legs
  [MUSCLE.QUADRICEPS]: messages.quadriceps,
  [MUSCLE.GLUTES]: messages.glutes,
  [MUSCLE.HAMSTRINGS]: messages.hamstrings,
  [MUSCLE.CALVES]: messages.calves,
  [MUSCLE.ABDUCTORS]: messages.abductors,
  [MUSCLE.ADDUCTORS]: messages.adductors,
  [MUSCLE.HIP_FLEXORS]: messages.hipFlexors,

  // Abdomen
  [MUSCLE.ABS]: messages.abs,
  [MUSCLE.OBLIQUES]: messages.obliques

}

export const MUSCLE_COMBINATIONS = {
  ARMS_SHOULDERS: [
    MUSCLE.SHOULDERS,
    MUSCLE.BICEPS,
    MUSCLE.TRICEPS
    // MUSCLE.TRAPS,
    // MUSCLE.FOREARMS
  ],
  ARMS: [
    MUSCLE.TRICEPS,
    MUSCLE.BICEPS
    // MUSCLE.FOREARMS
  ],
  CHEST_TRICEPS: [
    MUSCLE.CHEST,
    MUSCLE.TRICEPS
  ],
  BACK: [
    MUSCLE.UPPER_BACK,
    MUSCLE.LATS,
    MUSCLE.MIDDLE_BACK,
    MUSCLE.LOWER_BACK,
    MUSCLE.TRAPS
  ],
  CHEST_BACK: [
    MUSCLE.CHEST,
    MUSCLE.LATS,
    MUSCLE.UPPER_BACK,
    MUSCLE.MIDDLE_BACK,
    MUSCLE.LOWER_BACK,
    MUSCLE.TRAPS
  ],
  UPPER_BODY: [
    MUSCLE.CHEST,
    MUSCLE.UPPER_BACK,
    MUSCLE.ABS,
    MUSCLE.OBLIQUES,
    MUSCLE.LATS,
    MUSCLE.MIDDLE_BACK,
    MUSCLE.LOWER_BACK,
    MUSCLE.SHOULDERS,
    MUSCLE.TRICEPS,
    MUSCLE.BICEPS,
    // MUSCLE.FOREARMS,
    MUSCLE.TRAPS
    // MUSCLE.NECK
  ],
  LEGS: [
    MUSCLE.QUADRICEPS,
    MUSCLE.GLUTES,
    MUSCLE.HAMSTRINGS,
    MUSCLE.CALVES,
    MUSCLE.ABDUCTORS,
    MUSCLE.ADDUCTORS,
    MUSCLE.HIP_FLEXORS
  ],
  ABS: [
    MUSCLE.ABS,
    MUSCLE.OBLIQUES
  ],
  FULL_BODY: Object.values(MUSCLE)
}

export const MUSCLE_COMBINATION_KEY = {
  ARMS_SHOULDERS: 'ARMS_SHOULDERS',
  ARMS: 'ARMS',
  CHEST_TRICEPS: 'CHEST_TRICEPS',
  BACK: 'BACK',
  CHEST_BACK: 'CHEST_BACK',
  UPPER_BODY: 'UPPER_BODY',
  LEGS: 'LEGS',
  ABS: 'ABS',
  FULL_BODY: 'FULL_BODY'
}

export const MUSCLE_COMBINATIONS_MESSAGE = defineMessages({
  ARMS_SHOULDERS: {
    id: 'muscleCombinations.armsShoulders',
    defaultMessage: 'Arms & Shoulders',
    description: 'The label used for the arms and shoulders.'
  },
  SHOULDERS: {
    id: 'muscleCombinations.shoulder',
    defaultMessage: 'Shoulders',
    description: 'The label used for the shoulders.'
  },
  ARMS: {
    id: 'muscleCombinations.arms',
    defaultMessage: 'Arms',
    description: 'The label used for the arms.'
  },
  BACK: {
    id: 'muscleCombinations.back',
    defaultMessage: 'Back',
    description: 'The label used for the arms.'
  },
  CHEST_TRICEPS: {
    id: 'muscleCombinations.chestTriceps',
    defaultMessage: 'Chest & Triceps',
    description: 'The label used for the chest and triceps'
  },
  CHEST_BACK: {
    id: 'muscleCombinations.chestBack',
    defaultMessage: 'Chest & Back',
    description: 'The label used for the chest and back.'
  },
  UPPER_BODY: {
    id: 'muscleCombinations.upperBody',
    defaultMessage: 'Upper Body',
    description: 'The label used for the upper body.'
  },
  LEGS: {
    id: 'muscleCombinations.legs',
    defaultMessage: 'Legs',
    description: 'The label used for the legs.'
  },
  ABS: {
    id: 'muscleCombinations.abs',
    defaultMessage: 'Abs',
    description: 'The label used for the abs.'
  },
  FULL_BODY: {
    id: 'muscleCombinations.fullBody',
    defaultMessage: 'Full Body',
    description: 'The label used for the full body.'
  }
})

export const MUSCLE_GROUP = {
  ABS: [
    MUSCLE.ABS,
    MUSCLE.OBLIQUES
  ],
  ARMS: [
    MUSCLE.TRICEPS,
    MUSCLE.BICEPS,
    MUSCLE.FOREARMS
  ],
  BACK: [
    MUSCLE.NECK,
    MUSCLE.UPPER_BACK,
    MUSCLE.LATS,
    MUSCLE.MIDDLE_BACK,
    MUSCLE.LOWER_BACK
  ],
  CALVES: [
    MUSCLE.CALVES
  ],
  CHEST: [
    MUSCLE.CHEST
  ],
  FULL_BODY: Object.values(MUSCLE),
  GLUTES: [
    MUSCLE.GLUTES
  ],
  HAMSTRINGS: [
    MUSCLE.HAMSTRINGS
  ],
  LEGS: [
    MUSCLE.QUADRICEPS,
    MUSCLE.GLUTES,
    MUSCLE.HAMSTRINGS,
    MUSCLE.CALVES,
    MUSCLE.ABDUCTORS,
    MUSCLE.ADDUCTORS,
    MUSCLE.HIP_FLEXORS
  ],
  QUADRICEPS: [
    MUSCLE.QUADRICEPS
  ],
  SHOULDERS: [
    MUSCLE.SHOULDERS
  ],
  UPPER_BODY: [
    MUSCLE.CHEST,
    MUSCLE.UPPER_BACK,
    MUSCLE.LATS,
    MUSCLE.MIDDLE_BACK,
    MUSCLE.LOWER_BACK,
    MUSCLE.SHOULDERS,
    MUSCLE.TRICEPS,
    MUSCLE.BICEPS,
    MUSCLE.FOREARMS,
    MUSCLE.TRAPS,
    MUSCLE.NECK
  ]
}

export const MUSCLE_GROUP_KEY = {
  ABS: 'ABS',
  ARMS: 'ARMS',
  BACK: 'BACK',
  CALVES: 'CALVES',
  CHEST: 'CHEST',
  FULL_BODY: 'FULL_BODY',
  GLUTES: 'GLUTES',
  HAMSTRINGS: 'HAMSTRINGS',
  LEGS: 'LEGS',
  QUADRICEPS: 'QUADRICEPS',
  SHOULDERS: 'SHOULDERS',
  UPPER_BODY: 'UPPER_BODY'
}

export const MUSCLE_ANTAGONIST = {
  CHEST_LATS: [
    MUSCLE.CHEST,
    MUSCLE.LATS
  ],
  TRAPS_DELTOIDS: [
    MUSCLE.SHOULDERS,
    MUSCLE.TRAPS
  ],
  QUADRICEPS_HAMSTRINGS: [
    MUSCLE.QUADRICEPS,
    MUSCLE.HAMSTRINGS
  ],
  BICEPS_TRICEPS: [
    MUSCLE.BICEPS,
    MUSCLE.TRICEPS
  ]
}

export const MUSCLE_GROUP_MESSAGE = defineMessages({
  ABS: {
    id: 'majorMuscle.abs',
    defaultMessage: 'Abs',
    description: 'The label used for the abs.'
  },
  ARMS: {
    id: 'majorMuscle.arms',
    defaultMessage: 'Arms',
    description: 'The label used for the arms.'
  },
  BACK: {
    id: 'majorMuscle.back',
    defaultMessage: 'Back',
    description: 'The label used for the arms.'
  },
  CHEST: {
    id: 'majorMuscle.chest',
    defaultMessage: 'Chest',
    description: 'The label used for the chest and back.'
  },
  CALVES: {
    id: 'majorMuscle.calves',
    defaultMessage: 'Calves',
    description: 'The label used for the chest and back.'
  },
  FULL_BODY: {
    id: 'majorMuscle.fullBody',
    defaultMessage: 'Full Body',
    description: 'The label used for the full body.'
  },
  GLUTES: {
    id: 'majorMuscle.glutes',
    defaultMessage: 'Glutes',
    description: 'The label used for the chest and triceps'
  },
  HAMSTRINGS: {
    id: 'majorMuscle.hamstrings',
    defaultMessage: 'Hamstrings',
    description: 'The label used for the chest and triceps'
  },
  LEGS: {
    id: 'majorMuscle.legs',
    defaultMessage: 'Legs',
    description: 'The label used for the legs.'
  },
  QUADRICEPS: {
    id: 'majorMuscle.quadriceps',
    defaultMessage: 'Quadriceps',
    description: 'The label used for the legs.'
  },
  SHOULDERS: {
    id: 'majorMuscle.shoulders',
    defaultMessage: 'Shoulders',
    description: 'The label used for the shoulders.'
  },
  UPPER_BODY: {
    id: 'majorMuscle.upperBody',
    defaultMessage: 'Upper Body',
    description: 'The label used for the upper body.'
  }
})

export const MINOR_MUSCLES = [
  MUSCLE.FOREARMS,
  MUSCLE.HIP_FLEXORS,
  MUSCLE.ABDUCTORS,
  MUSCLE.ADDUCTORS,
  MUSCLE.CALVES,
  MUSCLE.NECK
]

export const MINOR_MUSCLE_KEYS = MINOR_MUSCLES.map(val => MUSCLE_TO_KEY[val])

export const MUSCLE_GROUPS_TO_MUSCLES = {
  [MUSCLE.SHOULDERS]: [
    MUSCLE.SHOULDERS,
    MUSCLE.INFRASPINATUS
  ],
  [MUSCLE.GLUTES]: [
    MUSCLE.GLUTES,
    MUSCLE.ABDUCTORS
  ],
  [MUSCLE.UPPER_BACK]: [
    MUSCLE.TRAPS,
    MUSCLE.LATS,
    MUSCLE.NECK,
    MUSCLE.INFRASPINATUS
  ],
  [MUSCLE.MIDDLE_BACK]: [
    MUSCLE.TRAPS,
    MUSCLE.LATS
  ]
}
